const UTCDateToLocalDate = date => {
  const offset = new Date().getTimezoneOffset() / 60;
  const hours = new Date(date).getHours();

  return new Date(date).setHours(hours - offset);
};

export default UTCDateToLocalDate;
